import React from "react";
import LoginService from "../../login/loginService";
import { Modal, InputGroup, Button } from "react-bootstrap";
import { toast , ToastContainer } from "react-toastify";
import LoadSpinner from "../../../common/spinner/loadSpinner";

export default class OtpModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      otp: "",
    };
  }

  changeText = (event) => {
    this.setState({ otp: event.target.value });
  };

  submitOtp = () => {
    const {
      cid,
      password,
      cfAzienda,
      deviceUUID,
      loginService,
      onSuccess,
      onError,
    } = this.props;

    loginService.otpCheck(
      cid,
      password,
      cfAzienda,
      deviceUUID,
      this.state.otp,
      () => {
      sessionStorage.setItem("loginSuccess", "true");
      this.setState({ otp: "", loading: false });
      onSuccess();
    },
      (error) => {
      console.error("Errore OTP:", error);
      toast.error("Codice OTP errato, riprova.");
      this.setState({ loading: false });
      onError();
    }
    );
  };

  resetState = () => {
    this.setState({ otp: "" });
  };

  render() {
    return (
        <>
      <Modal show={this.props.show} onHide={() => {
                                                    this.resetState();
                                                    this.props.onHide();}}>
        <Modal.Header closeButton>
          <Modal.Title>Inserisci OTP</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input
            type="text"
            className="form-control"
            placeholder="Codice OTP"
            maxLength={6}
            value={this.state.otp}
            onChange={this.changeText}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
                                        this.resetState();
                                        this.props.onHide();
                                        toast.warning("Se effettui di nuovo il login, riceverai un nuovo codice OTP via email.");
                                      }}>
            Annulla
          </Button>
          <Button variant="primary" onClick={this.submitOtp} disabled={this.state.loading ||this.state.otp.length < 6}>
            {this.state.loading ? (
                  <LoadSpinner/>
                ) : (
                  "Invia OTP"
                )}
          </Button>
        </Modal.Footer>
      </Modal>
      <ToastContainer position="top-right" autoClose={3000} />
      </>
    );
  }
}
